// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { AlertSeverity } from "./Shared.AlertSeverity.gen";
import { AlertDigestMode } from "./Shared.AlertDigestMode.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty, IsOptional, MaxLength } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IAlertRecipient {
	id: string | undefined;

	organizationId: string | undefined;

	facilityId: string | undefined;

	emailAddress: string;

	minSeverity: AlertSeverity;

	digestMode: AlertDigestMode;

	notifyOnAutoResolve: boolean;

	isVerified: boolean;

	verificationToken: string | undefined;

	verificationSentAtUtc: string | undefined;

	verifiedAtUtc: string | undefined;

	unsubscribedAtUtc: string | undefined;

	createdAtUtc: string | undefined;

	$type?: string | undefined;
}
export class AlertRecipient {
	constructor(data?: IAlertRecipient) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.verificationSentAtUtc) { this.verificationSentAtUtc = new Date(data.verificationSentAtUtc); }
		if (data.verifiedAtUtc) { this.verifiedAtUtc = new Date(data.verifiedAtUtc); }
		if (data.unsubscribedAtUtc) { this.unsubscribedAtUtc = new Date(data.unsubscribedAtUtc); }
		if (data.createdAtUtc) { this.createdAtUtc = new Date(data.createdAtUtc); }
	}

	id: string | undefined;

	organizationId: string | undefined;

	facilityId: string | undefined;

	@IsNotEmpty()
	@MaxLength(320)
	emailAddress: string = "";

	minSeverity: AlertSeverity = 0;

	digestMode: AlertDigestMode = 0;

	notifyOnAutoResolve: boolean = false;

	isVerified: boolean = false;

	@IsOptional()
	@MaxLength(64)
	verificationToken: string | undefined;

	verificationSentAtUtc: Date | undefined;

	verifiedAtUtc: Date | undefined;

	unsubscribedAtUtc: Date | undefined;

	createdAtUtc: Date | undefined = new Date();

	static $type: string = "CoreApi.Models.Alerts.AlertRecipient, ";
	$type?: string | undefined = AlertRecipient.$type;
}

